import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import AdmissionDetail from "./pages/AdmissionDetail";
import RadiologyManagement from "./pages/RadiologyManagement";
import LabOrdersManagement from "./pages/LabOrdersManagement";
import IpdBillingManagement from "./pages/IpdBillingManagement";
import IpdFilesManagement from "./pages/IpdFilesManagement";
import ProcedureMaster from "./pages/ProcedureMaster";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/ipd-admission" replace />} />
          <Route path="/ipd-admission" element={<AdmissionDetail />} />
          <Route path="/radiology" element={<RadiologyManagement />} />
          <Route path="/lab-orders" element={<LabOrdersManagement />} />
          <Route path="/ipd-billing" element={<IpdBillingManagement />} />
          <Route path="/ipd-files" element={<IpdFilesManagement />} />
          <Route path="/procedure-master" element={<ProcedureMaster />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
